module.exports = {
  businessNumber: 'Номер операции',
  businessType: 'Тип операции',
  mblNo: 'Основной номер накладной',
  customer: 'Клиент',
  carrier: 'Перевозчик',
  vessel: 'Название судна',
  shippingCompanyContractNo: 'Номер договора судоходной компании',
  voyageFlight: 'Рейс/Рейс (авиа)',
  SeaPortOfLoading: 'Порт отправления/Порт погрузки (морской порт)',
  portOfDestination: 'Порт назначения',
  dischargingPortCode: 'Порт разгрузки',
  dateOfDeparture: 'Дата отправления',
  businessDate: 'Дата операции',
  businessReferenceNumber: 'Референс операции',
  bookingAgent: 'Агент по бронированию',
  dateOfCreation: 'Дата создания',
  dateOfProof: 'Дата документа',
  operation: 'Действие',
  sales: 'Продажи',
  salesDepartment: 'Отдел продаж',
  CustomerService: 'Обслуживание клиентов',
  Documents: 'Документация',
  accrued: 'Начислено',
  status: 'Статус',
  actualChargedWeight: 'Фактический вес для тарификации',
  profit: 'Прибыль',
  totalIncome: 'Общий доход',
  totalCost: 'Общая себестоимость',
  closingAccountStatus: 'Статус переноса',
  hasReceivable: 'Принудительный перенос',
  profitExcludingTax: 'Прибыль (без налога)',
  totalIncomeExcludingTax: 'Доход (без налога)',
  totalCostExcludingTax: 'Себестоимость (без налога)',
  profitClosingAccount: 'Прибыль к переносу',
  totalIncomeClosingAccount: 'Доход к переносу',
  totalCostClosingAccount: 'Себестоимость к переносу',
  hasReceivableTotal: 'Принудительное начисление',
  profitCommission: 'Прибыль по комиссии в этом периоде',
  totalIncomeCommission: 'Доход по комиссии в этом периоде',
  totalCostCommission: 'Себестоимость по комиссии в этом периоде',
  provisionedStatus: 'Статус начисления',
  refundCommission: 'Комиссия',
  closingAccountRevenue: 'Перенесенный доход',
  closingAccountCost: 'Перенесенная себестоимость',
  invoiceCost: 'Себестоимость по полученным счетам',
  payablesWriteOfStatus: 'Статус проверки кредиторской задолженности',
  receivablesWriteOfStatus: 'Статус проверки дебиторской задолженности',
  payablesConfirmOfStatus: 'Статус подтверждения кредиторских расходов',
  receivablesConfirmOfStatus: 'Статус подтверждения дебиторских расходов',
  accrualDate: 'Дата начисления',
  creator: 'Создатель операции',
  receivables: 'Дебиторская задолженность',
  payables: 'Кредиторская задолженность',
  englishDescriptionOfGoods: 'Наименование товара на английском',
  chineseDescriptionOfGoods: 'Наименование товара на китайском',
  consignationCompany: 'Заказчик',
  settlementCompany: 'Расчетная единица',
  destinationAgent: 'Агент порта назначения',
  nominatedAgent: 'Уполномоченный агент по грузу',
  destinationAgentShortName: 'Агент порта назначения (сокр.)',
  nominatedAgentShortName: 'Уполномоченный агент по грузу (сокр.)',
  containerNo: 'Номер контейнера',
  amountRange: 'Диапазон суммы',
  profitRange: 'Диапазон прибыли',
  localAmountRange: 'Диапазон суммы в базовой валюте',
  SubmissionDateTime: 'Время подачи',
  AuditDateTime: 'Время проверки',
  feeStatus: 'Статус расходов',
  redChargesOrNot: 'Корректировка (красное сторно)',
  portOfLoading: 'Порт погрузки/отправления',
  AirPortOfLoading: 'Порт погрузки/отправления (аэропорт)',
  seaportOfDischarge: 'Порт разгрузки (морской порт)',
  airportOfDischarge: 'Порт разгрузки (аэропорт)',
  airportOfDestination: 'Порт назначения (аэропорт)',
  operationDepartment: 'Операционный отдел',
  invoiceDate: 'Дата выставления счета',
  invoiceDateAR: 'Дата выставления счета дебиторской задолженности',
  financialaDate: 'Финансовая дата',
  solicitationType: 'Тип сбора груза',
  warehouseNo: 'Номер поступления на склад',
  itemNo: 'Номер проекта',
  receivablesInvoicingStatus: 'Статус выставления счета',
  receivablesInvoicingStatusAr: 'Статус выставления счета дебиторской задолженности',
  businessStatus: 'Статус операции',
  customJobType: 'Пользовательский тип операции',
  separateNumber: 'Номер частичной накладной',
  containerDescription: 'Описание объема контейнера',
  designationAgent: 'Уполномоченный агент по грузу',
  masterBLFreightTerm: 'Условия фрахта главной накладной',
  HBLFreightClause: 'Условия фрахта частичной накладной',
  IncoTerm: 'Торговые условия',
  FLCLType: 'Тип консолидации',
  SeaExportFLCLType: 'Тип консолидации (морской экспорт)',
  SeaImportFLCLType: 'Тип консолидации (морской импорт)',
  OperateType: 'Режим операции',
  AirExportOperateType: 'Режим операции (авиаэкспорт)',
  AirImportOperateType: 'Режим операции (авиаимпорт)',
  UserDefinedField1: 'Пользовательское поле 1',
  UserDefinedField2: 'Пользовательское поле 2',
  UserDefinedField3: 'Пользовательское поле 3',
  ManageAuditStatus: 'Статус проверки прибыли',
  paymentRequestNumber: 'Номер заявки на оплату',
  placeOfDelivery: 'Место доставки',
  changeState: 'Статус изменения заказа',
  grossProfitRate: 'Валовая маржа',
  railwayTransportLine: 'Маршрут (железная дорога)',
  route: 'Авиалиния',
  exportLoadingPlan: 'Экспорт плана погрузки',
  exportSalesReport: 'Экспорт отчета о продажах',
  moreOperations: 'Дополнительные действия',
  routeOperation: 'Операции с авиалинией',
  completeBooking: 'Завершить бронирование',
  warehousing: 'Загрузка на склад',
  mountingBoard: 'Погрузка',
  pullGood: 'Отгрузка',
  applicationForFlightAdjustment: 'Запрос на корректировку рейса',
  allocateFlights: 'Переназначение рейса',
  confirmCabinAllocation: 'Подтверждение размещения',
  cancelConfirmationOfCabinAllocation: 'Отмена подтверждения размещения',
  copyIncomingData: 'Копирование данных загрузки',
  otherRemarks: 'Прочие примечания',
  otherExpenses: 'Прочие расходы',
  delivery: 'Доставка',
  deliveryAgent: 'Агент доставки',
  uploadBoardPhotos: 'Загрузка фото погрузки',
  subLabel: 'Разделение меток',
  prefabricatedMasterOrder: 'Предварительный основной документ',
  prefabricationOrderSplitting: 'Предварительный дополнительный документ',
  printMasterOrder: 'Печать основного документа',
  printSplit: 'Печать дополнительного документа',
  track: 'Отслеживание',
  takeOff: 'Вылет',
  arrival: 'Прибытие',
  Discharge: 'Разгрузка',
  billOfLadingInquiry: 'Поиск коносамента',
  expandAll: 'Развернуть все',
  putItAllAway: 'Свернуть все',
  noBusinessFlight: 'Рейс без операций',
  heavy: 'Вес',
  takeOff2: 'Вылетел',
  arrivedAtPort: 'Прибыл',
  size: 'Размер',
  cabinAllocationStatus: 'Статус размещения',
  installationInstructions: 'Инструкция по погрузке',
  photograph: 'Фотосъемка',
  guanFeng: 'Таможенная пломба',
  singleCopy: 'Связанные документы',
  flightInformationEmpty: 'Информация о рейсе отсутствует.',
  lockFlight: 'Блокировка рейса',
  unlockFlight: 'Разблокировка рейса',
  cabinAllocationStatusConfirmed: 'Установить статус бронирования билета как подтверждённый?',
  confirmationSucceeded: 'Подтверждение успешно!',
  confirmThis: 'Подтвердить это',
  cabinAllocationStatusUnconfirmed: 'Установить статус бронирования билета как неподтверждённый?',
  hair: 'Вес брутто',
  selectBookedOrder: 'Пожалуйста, выберите заказ для бронирования!',
  preprint: 'Предварительная печать',
  undoPrinting: 'Отменить печать',
  temporaryStorage: 'Временное сохранение',
  bookingNumber: 'Номер бронирования',
  bookingTime: 'Время бронирования',
  descriptionOfBookingResults: 'Описание результата бронирования',
  declared: 'Уже прошло таможенное оформление',
  enterDeliveryAgent: 'Пожалуйста, введите агента по доставке.',
  whetherTakePhotos: 'Фотографировать?',
  siteRemarks: 'Примечания на месте',
  otherInstructions: 'Другие пояснения',
  enterBillOfLadingNumber: 'Пожалуйста, введите номер коносамента.',
  takeoffTime: 'Время вылета',
  deliveryTime: 'Время доставки',
  trackingFlight: 'Отслеживание рейса',
  trackingArrival: 'Отслеживание прибытия',
  trackingDelivery: 'Отслеживание доставки',
  enterDepartureTime: 'Пожалуйста, введите время вылета.',
  enterArrivalTime: 'Пожалуйста, введите время прибытия.',
  enterDeliveryTime: 'Пожалуйста, введите время доставки.',
  receivingOutsideWarehouse: 'Приём груза (внешний склад)',
  warehousingTime: 'Время загрузки на склад:',
  damagedAndDamp: 'Имеются повреждения/намокание',
  photo: 'Фотография',
  selectPhotos: 'Выбрать фото',
  deletePhotos: 'Удалить фото',
  selectWarehousingDate: 'Пожалуйста, выберите дату поступления на склад!',
  enterSubLabel: 'Ввод подкатегорий',
  receiptNo: 'Номер возвратной накладной',
  pleaseEnterSubLabel: 'Пожалуйста, введите подкатегории.',
  uploading: 'Идёт загрузка',
  oneFileVolumn2MB: '1 файл превышает 2MB и не может быть загружен.',
  failedDeleteFile: 'Ошибка удаления файла!',
  uploadSucceeded: 'Загрузка успешна',
  uploadFailed: 'Загрузка не удалась',
  uploadComplete: 'Загрузка не удалась',
  notExceed6Lines: 'Максимум не более 6 строк!',
  nodeName: 'Название узла',
  nodeState: 'Статус узла',
  warningLevel: 'Уровень предупреждения',
  warningAt: 'Время предупреждения',
  line: 'Маршрут',
  airTransportArea: 'Зона авиаперевозок',
  operationalResponsibilities: 'Операционные обязанности',
  assignmentOfResponsibilities: 'Распределение обязанностей',
  roleList: 'Список ролей',
  assignedResponsibilities: 'Обязанности уже распределены',
  listOfResponsibilities: 'Список обязанностей',
  NoVoucherGeneratedReceivable: 'Несформированные документы дебиторской задолженности',
  NoVoucherGeneratedPayable: 'Несформированные документы кредиторской задолженности',
  VoucherGeneratedReceivable: 'Сформированные документы дебиторской задолженности',
  VoucherGeneratedPayable: 'Сформированные документы кредиторской задолженности',
  TenTicketsAtTheSameTime: 'Можно просматривать одновременно до 10 операций. Пожалуйста, сделайте новый выбор.',
  DataChangedToReopen: 'Данные были изменены. Пожалуйста, откройте заново для редактирования.',
  JobOpenedAndCannotDelete: 'Эта операция уже открыта в новой вкладке и не может быть удалена!',
  AreWantToDeleteBusiness: 'Подтвердите удаление данной операции?',
  DoToDeleteTheTicket: 'Удалить чек?',
  AreToDeleteTheBusiness: 'Подтверждаете удаление выбранных операций?',
  AreToConvertTheItem: 'Подтверждаете преобразование выбранных элементов?',
  ConversionSucceeded: 'Преобразование успешно',
  OperationDepartmentCannotBeEmpty: 'Операционный отдел не может быть пустым!',
  OrangeWorkingDaysFromETA: 'Оранжевый: менее 7 рабочих дней до ETA',
  RedWorkingDaysFromETA: 'Красный: менее 3 рабочих дней до ETA',
  BatchOfWholeSplicingType: 'Массовое изменение типа консолидации:',
  UploadedOnlyBeInFormat: 'Загружаемый файл должен быть в формате CSV!',
  ThatSOk: 'Строка',
  NotInPositiveOperation: 'Не в активном состоянии.',
  AreTicketsSubmitted: 'Отправить операцию?',
  IsTheTicketPreSubmitted: 'Предварительно отправить документ?',
  AreWantToWithdrawTicket: 'Подтверждаете отзыв данной операции?',
  BillOfLadingInformationTracking: 'Отслеживание информации по коносаменту',
  PleaseMaintainTheJumpAddress: 'Пожалуйста, укажите адрес перехода!',
  CannotBeEmpty: 'Не может быть пустым',
  AreWantToRemoveTicket: 'Подтверждаете удаление данного чека?',
  NoBusinessSelected: 'Операция не выбрана',
  IfForTheGoodsSame: 'Если для данного груза применяется тариф агента/судоходной компании, отметьте здесь',
  EspeciallyPeersThatUBISpace: 'Имеются в виду судоходные компании или партнеры, с которыми работает UBI',
  UnitKg: 'Единица: кг',
  UnitCubicMeter: 'Единица: м³',
  UnitTon: 'Единица: тонна',
  DoorNotBeenSavedPrinted: 'Несохраненные данные о пунктах не могут быть распечатаны!',
  CaseNo: 'Номер контейнера:',
  AllTheAssociationDoContinue: 'Все связанные данные будут удалены. Продолжить?',
  DetailsSeaborneExportGoodsXls: 'Детали морского экспортного груза.xls',
  FindTheTrailerLocationNow: 'Немедленно проверить местоположение тягача',
  EstimatedLoadingDate: 'Планируемая дата погрузки',
  SelectDateAndTime: 'Выберите дату и время',
  PrimaryDocNoAlreadyExists: 'Основной номер накладной уже существует',
  PleaseEnterTheFlightNumber: 'Введите номер рейса.',
  PleaseEnterETD: 'Введите ETD.',
  PleaseEnterAnAction: 'Введите операцию.',
  PleaseEnterTheRoute: 'Введите маршрут.',
  AreWantToAllocateFlight: 'Подтверждаете распределение рейса для {0} операций?',
  DeploymentSucceeded: 'Распределение успешно!',
  SuccessfullyPicturesAreYouSave: 'Успешно загружено: {0}, не удалось: {1} изображений. Подтвердить сохранение?',
  TheSelectedRecordMustSame: 'Выбранные записи должны иметь одинаковую ETD!',
  TheSelectedRecordsMustSame: 'Выбранные записи должны принадлежать одной авиакомпании!',
  PleaseWithTheSameMode: 'Выберите операции с одинаковым режимом работы',
  SiruiPleaseContactTheTroubleshooting: 'Не удалось отправить доверенность Sirui. Обратитесь к специалисту для проверки:',
  BusinessTodayIsNotCustoms: 'Операции с датой отправления позже сегодняшней не могут быть отменены',
  G7DataPush: 'Отправка данных G7',
  DropDown: 'Выпадающий список',
  TheBeenAddedToOrder: 'Дочерняя накладная уже добавлена в основную!',
  NotBoundYet: 'Ещё не привязано!',
  TheCostSharingAndSeparated: 'Текущая дочерняя накладная содержит распределённые затраты, разделение невозможно!',
  AreUnbindTheMasterOrder: 'Подтверждаете отмену привязки к основной накладной?',
  PleaseEnterOperatorInformation: 'Введите данные оператора!',
  TheIsIllegalPleaseEnter: 'Номер основной накладной некорректен, введите заново!',
  PleaseTheDesignatedShippingAgent: 'Укажите агента по грузу!',
  TheseWillBeSetJoin: 'Эти поля отличаются от основной накладной. При добавлении они будут изменены. Подтверждаете?',
  TheNotExceed6Lines: 'Максимум 6 строк!',
  TheNotExceed7Lines: 'Максимум 7 строк!',
  ThereMasterTicketThisPerformed: 'Основная накладная содержит затраты, операция невозможна!',
  TheTicketIfYouSwitch: 'Дочерняя накладная привязана к единственной основной. Смена режима удалит её. Подтверждаете?',
  TheTheBindingRelationshipSwitch: 'Дочерняя накладная привязана. Смена режима отменит привязку. Подтверждаете?',
  SwitchAMasterTicketSwitch: 'Переключиться в режим "Одна основная/несколько дочерних"? Система создаст основную накладную. Подтверждаете?',
  DateExceededCreditControl: 'Партнёр превысил срок оплаты!',
  AmountExceededCreditControl: 'Партнёр превысил лимит!',
  DateAndAmountExceededCreditControl: 'Партнёр превысил лимит и срок оплаты!',
  ThisHasExceededCreditControl: 'Этот партнёр превысил кредитный лимит',
  ItAEntrustingUnitAgent: 'Не может быть доверителем или агентом по грузу',
  ThisHasBeenAutomaticallyCleared: 'Поле автоматически очищено',
  JoinTheTicketSuccessfully: 'Дочерняя накладная успешно добавлена!',
  ThereSplitTicketTheTicket: 'Основная накладная содержит одну дочернюю. Удаление приведёт к её удалению. Подтверждаете?',
  TheTicketHasBeenRemoved: 'Основная накладная удалена!',
  AreRemoveThisSubTicket: 'Подтверждаете удаление дочерней накладной из основной?',
  AttachmentDescription: 'Описание вложений',
  AirlineCachePleaseResetAgain: 'Данные авиакомпании не найдены в кеше. Сбросьте кеш и попробуйте снова',
  ResettingTheModifiedContentContinue: 'Сброс значений перезапишет изменения. Продолжить?',
  PleaseEnterTheSplitNumber: 'Введите номер дочерней накладной',
  AlreadyExists: 'Уже существует!',
  DetailsAirExportGoodsXls: 'Детали авиагрузов на экспорт.xls',
  PleaseSelectWarehousingData: 'Выберите данные по размещению на складе!',
  AreToDeleteThisData: 'Подтверждаете удаление этих данных размещения?',
  TheRateMAndAdjusted: 'TOTAL меньше поддерживаемого тарифа M. Корректировка невозможна!',
  AirlineInformation: 'Данные авиакомпании',
  PleaseSelectAFee: 'Выберите статью затрат',
  SelectMainOrder: 'Выбор основной накладной',
  ManualInput: 'Ручной ввод:',
  TheOrderNumberIsIllegal: 'Неверный номер основной накладной!',
  WarehousingInstructions: 'Инструкции по размещению',
  OtherInstructions: 'Прочие указания:',
  GoodsIntoThisWarehouse: 'Груз размещён на нашем складе',
  NeedPhotos: 'Требуется фото',
  AttachedDocuments: 'Приложить случайные файлы',
  Generate: 'Сгенерировать',
  Save: 'Сохранить?',
  PleaseTheEstimatedWarehousingTime: 'Введите предполагаемое время поступления на склад!',
  AirlineCompany: 'Авиакомпания:',
  Flight: 'Рейс:',
  FieldOperation: 'Операции на месте:',
  SendFieldOperation: 'Отправить операции на месте',
  EntrustedWeight: 'Вес заказа',
  NumberOfBookingPieces: 'Количество бронирований',
  BookingWeight: 'Вес бронирования',
  BookingVolume: 'Объем бронирования',
  PleaseFillInTheFlight: 'Заполните рейс!',
  PromissoryHaveBecomeOfficialBusiness: 'Эта сделка уже является официальной.',
  ThisApprovalStatusAndEdited: 'Этот заказ находится на финансовом согласовании и не может быть изменен.',
  AreToConvertTheItem2: 'Вы уверены, что хотите преобразовать выбранные элементы?',
  TheDoesNotComplyRules: 'Основной номер накладной не соответствует правилам!',
  DoubleOfLadingHeaderUp: 'Двойной щелчок по заголовку накладной для открытия',
  SmallNumberOfVotes: 'Количество мелких накладных',
  NumberOfPrimaryVotes: 'Количество основных накладных',
  ThePleaseMaintainTheFirst: 'Основной номер накладной пуст, пожалуйста, заполните его',
  TheTheNewlySelectedContinue: 'Номер рейса, авиакомпания, дата отправления, дата прибытия, способ выпуска груза и условия фрахта основной накладной для новой мелкой накладной не совпадают с основной накладной. Система изменит мелкую накладную. Продолжить?',
  ClickSelectTheGoodsCode: 'Нажмите пробел для выбора кода категории груза',
  AreSureVoidThisTicket: 'Вы уверены, что хотите аннулировать эту сделку?',
  AllChargesBeDeleted: 'Все расходы будут удалены!',
  SellingPriceCalculationCompleted: 'Расчет продажной цены завершен',
  OperationOfTicketCannotEdited: 'Вы не являетесь оператором этой сделки и не можете ее редактировать.',
  ActualNotifierCannotBeBlank: 'Фактическое уведомляющее лицо не может быть пустым',
  SpecifiedFreightAgentCannotEmpty: 'Указанный грузовой агент не может быть пустым',
  ArrivalDateCannotBlank: 'Дата прибытия не может быть пустой',
  OperationDepartmentCannotBlank: 'Операционный отдел не может быть пустым',
  ExpectedArrivalDateCannotBlank: 'Предполагаемая дата прибытия не может быть пустой',
  PleaseReselect: 'Пожалуйста, выберите снова',
  EstimatedProfitNotCompanyRegulations: 'Расчетная прибыль этой сделки не соответствует корпоративным нормам {0}, подтверждаете сохранение?',
  ReceivableExpensesMustBeEntered: 'Необходимо ввести подлежащие оплате расходы.',
  PayableExpensesMustBeEntered: 'Необходимо ввести расходы к оплате.',
  BlockedCannotUsedContactCustomerManagement: '[{0}] заблокирован, обратитесь к менеджеру по работе с клиентами.',
  CompanyBlockedCannotUsedWithReason: '[{0}] заблокирован. Причина отключения: [{1}].',
  CompanyBlockedCannotUsed: '[{0}] заблокирован.',
  exportOption: 'Опции экспорта',
  exportDescription: 'Описание экспорта',
  dataNotMerged: 'Данные не объединяются',
  noMoreReminders: 'Больше не напоминать',
  UsCustomsClearance: 'Растаможка в США',
  CustomerInformation: 'Данные клиента',
  DeclarationMaterials: 'Декларационные данные',
  TopSecretInformation: 'Совершенно секретные данные',
  DeletionIsUnrecoverable: 'Удаление невозможно отменить, подтверждаете удаление данных?',
  PleaseEnterOnLine: 'Введите {1} в строке {0}',
  CustomerName: 'Наименование товара клиента',
  CustomsClearanceProductName: 'Таможенное наименование',
  NumberOfPackages: 'Количество упаковок',
  NumberOfGoods: 'Количество грузовых мест',
  CustomsClearanceUnit: 'Таможенный орган',
  Export7501: 'Экспорт формы 7501',
  ExportInvoicePackingList: 'Экспорт инвойса и упаковочного листа',
  GenerateReceivableExpense: 'Сформировать дебиторскую задолженность',
  GeneratePayableExpenses: 'Сформировать кредиторскую задолженность',
  CopyAsCustomerData: 'Копировать как клиентские данные',
  CopyAsDeclarationData: 'Копировать как декларационные данные',
  CopyAsTopSecretInformation: 'Копировать как совершенно секретные данные',
  PdfType: 'Тип PDF',
  MergeProductNamesWhenFiles: 'Объединять одноименные товары при создании файла',
  ShowTax: 'Отображать налоги',
  ShowChinaSurtax: 'Отображать китайский дополнительный налог',
  ShowMargin: 'Отображать гарантийный депозит',
  MarginAmount: 'Сумма гарантийного депозита',
  TotalNetWeight: 'Общий нетто-вес',
  TotalValue: 'Общая стоимость груза',
  TotalTariff: 'Итого таможенных пошлин',
  TotalOtherExpenses: 'Итого прочих расходов',
  UnitWeight: 'Вес единицы груза',
  ItemPricing: 'Цена за единицу товара',
  TotalPriceOfGoods: 'Общая стоимость товара',
  ChinaAdditionalTaxRate: 'Ставка китайского дополнительного налога',
  ChinasSurtaxTariff: 'Правила китайского дополнительного налога',
  ChinaSurtaxClause: 'Положения о китайском дополнительном налоге',
  AccountsReceivableGeneratedSuccessfully: 'Дебиторская задолженность успешно сформирована.',
  PayableExpensesGeneratedSuccessfully: 'Кредиторская задолженность успешно сформирована.',
  ThePleaseConfirmWhetherData: 'Очистка данных необратима. Подтвердите очистку?',
  TheSureYouWantData: 'Удаление строки необратимо. Подтвердите удаление?',
  BusinessDateChangedUpdateExchangeRate: 'Дата операции изменена. Обновите валютный курс для расходов.',
  CustomsClearance: 'Таможенное оформление',
  QuantityIsInconsistentOfEqSizeType: '【{eqSize}{eqType}】Несоответствие количества контейнеров и информации о загрузке',
  QuantityIsInconsistentOfCodeType: '【{containerCode}{containerType}】Несоответствие количества контейнеров и информации о погрузке на паллеты',
  syncChargesToExportJobMessage: 'Синхронизировано {total} записей: успешно {successCount}, неудачно {failCount}',
  syncChargesToExportJobFailMessage: '< span > Синхронизация < span style = "color: blue" > {total} < / span > Статья расходов < / span >, успех < span style = "color: green" > {successcount} < / span > один, неудача < span style = "color: red" > {failCount} < / span > один < / span > < br / >\n' +
    '< b > Причины следующие < / b > < br / >',
  ImportReceivablePpayableObjectNotEqualCustomer: 'Расход {no}: Объект расчета импортной дебиторской/кредиторской задолженности ≠ экспортер (доверитель)',
  BillGenerated: 'Расход {no}: Счет уже сформирован',
  InvoiceIssued: 'Расход {no}: Счет-фактура выставлен',
  AccountWrittenOff: 'Расход {no}: Проведено списание',
  PaymentApplication: 'Расход {no}: Заявка на оплату подана',
  ExpenseConfirmationYes: 'Расход {no}: Подтверждение расходов - Да',
  ExpenseStatusSubmitted: 'Расход {no}: Статус расходов - Отправлено',
  CollectionAdvancePayment: 'Расход {no}: Уже получен аванс',
  ExpensesGeneratedByVarianceProcessing: 'Расход {no}: Расходы, возникшие при обработке разницы',
  Shared: 'Расход {no}: Уже распределено',
  NotOperatingCannotSynchronized: 'Невозможно синхронизировать нестандартные заказы',
  ImportHasSynchronizedDispatchingInformation: '<b style="font-size:16px">Информация о транспорте для импортного заказа синхронизирована</b><br><span style="font-size:16px">Продолжить?</span>',
  MatchingConditionsForPushSOPReceiver: 'Условия соответствия получателей SOP',
  GenerateXChargeSyncRecords: 'Создано {num} записей синхронизации расходов',
  Density: 'Плотность',
  CommissionedDensity: 'Плотность поручения',
  ActualDensity: 'Фактическая плотность',
  EstimatedReviewer: 'Предварительный проверяющий',
  DateOfPreReview: 'Дата предварительной проверки',
  EnteredXNotMatchAirlineCode: 'Введенный код рейса {0} не соответствует Airline Code авиакомпании',
  EnteredXNotMatchAirlinePrefix: 'Первые три цифры введенного MAWB {0} не соответствуют префиксу авиакомпании',
  HasPackingFeeEnterWarehouse: 'Есть стоимость упаковки, введите информацию о складе!',
  SuccessSyncInfo: 'Синхронизация информации успешна',
  Search: 'Поиск',
  Clear: 'Очистить',
  ShipperName: 'Наименование отправителя',
  ConsigneeName: 'Наименование получателя',
  NotifyPartyName: 'Наименование уведомляющей стороны',
  AfterToBeRevokedSynchronize: 'После подтверждения синхронизации отмена невозможна. Подтвердить синхронизацию?',
  PleaseADataToDelete: 'Выберите данные для удаления!',
  CreatePaymentRequestSelectFee: 'Создание заявки на оплату - выбор расходов',
  PleaseSelectTheBill: 'Выберите счет.',
  YouViewOrPrintOthers: 'У вас нет прав на просмотр файлов, загруженных или распечатанных другими.',
  AgentCommissionBill: 'Счет агентских комиссий',
  TheWithdrawnAndCannotOperated: 'Операция отменена, действия невозможны',
  PleaseSelectTheForeignBill: 'Выберите зарубежный счет.',
  Equivalent: 'Эквивалент',
  EquivalentToRMB: 'Эквивалент в RMB',
  OperationFailed: 'Ошибка операции',
  FrontEndErrorCallbackFailed: 'Ошибка фронтенда: сбой обратного вызова',
  YouToEditTheAdministrator: 'У вас нет прав на редактирование данных, обратитесь к администратору',
  UploadingPleaseWait: 'Идет загрузка, подождите......',
  AssociateBusinessSOPNode: 'Связанный узел SOP бизнес-процесса',
  CustomsDuty: 'Таможенная пошлина',
  AddAmendmentFee: 'Добавление расходов на изменение заказа',
  AddNewBusiness: 'Добавление операции',
  Add: 'Добавить',
  Maintain: 'Сохранить',
  Modify: 'Изменить',
  PleaseEnterTheBusinessNumber: 'Введите номер операции!',
  ReceiptSuccessful: 'Квитанция успешно получена',
  WaitingForReceipt: 'Ожидание квитанции',
  SaveSuccessfully: 'Сохранение успешно',
  SendEmail: 'Отправить на email',
  SystemEmail: 'Системный email',
  CompanyEmail: 'Корпоративный email',
  PersonalEmail: 'Личный email',
  Submitted: 'Отправлено',
  DataSource: 'Источник данных',
  SystemInput: 'Системный ввод',
  PortAreaData: 'Данные портовой зоны',
  UpdateToPortAreaData: 'Обновить данные портовой зоны',
  NewExportClearancePolicy: 'Новые правила экспортного выпуска',
  YangshanAreaNovember152021: 'Таможенная зона Яньшань: 15 ноября 2021 г.',
  WaigaoqiaoAreaNovember222021: 'Таможенная зона Вайган: 22 ноября 2021 г.',
  GarbageManifest: 'Мусорный манифест',
  N1OnceTheManifestManifest: '1. Таможня строго запрещает мусорные манифесты! Согласно таможенным правилам, каждый предварительный манифест должен соответствовать фактической отгрузке. Если после отправки манифеста ваш груз не был отгружен (не успел на судно, изменение планов отгрузки и т.д.), такой манифест считается мусорным!',
  N2ManifestMustBeDeletion: '2. Пример мусорного манифеста: после изменения расписания судна старый предварительный манифест необходимо удалить, и только затем можно отправлять новый!',
  N3YuanOnTheManifest: '3. Последствия неудаления мусорного манифеста: не только повлияет на погрузку, но таможня может оштрафовать агента на 50 000 юаней и лишить лицензии! При обнаружении мусорного манифеста немедленно свяжитесь со службой поддержки для его удаления!',
  BusinessUUIDCannotBeEmpty: 'UUID операции не может быть пустым!',
  BillUUIDCannotBeEmpty: 'UUID счета не может быть пустым!',
  FileInformation: 'Информация о файле',
  BillingInformation: 'Информация о счете',
  DomesticWarehouse: 'Внутренний склад',
  ForeignWarehouse: 'Зарубежный склад',
  ExpectedTimeAtAmazonWarehouse: 'Планируемое время поступления на склад Amazon',
  ReferenceBoxNumber: 'Референсный номер контейнера',
  TotalDoesNotEqualCost: 'Сумма распределенных расходов по чекам не равна исходной сумме!',
  NameCannotBeEmpty: 'Имя не может быть пустым!',
  SOPOperationStatus: 'Статус выполнения SOP',
  AddSpecialFees: 'Добавить специальный сбор',
  TrailerTrackingUsageNotice: 'Инструкция по использованию трекера прицепов',
  N1SituationIncludingButDepartments: '1. Согласно законодательству, система обязана фиксировать запросы пользователей, включая (но не ограничиваясь) номер авто, оператора запроса и время, для предоставления доказательств по требованию уполномоченных органов.',
  N2ConsentBeforeQueryingCommunication: '2. Согласно закону, перед отслеживанием автомобиля необходимо получить согласие владельца. Пользователь должен заранее договориться о разрешении во избежание нарушения прав.',
  N3TheOwnersConsentConsequences: '3. Если пользователь запрашивает информацию без согласия владельца, вся юридическая ответственность ложится на пользователя.',
  N4ItToIrrelevantUser: '4. Даже при наличии разрешения используйте информацию строго в рамках авторизации. Разглашение третьим лицам влечет юридическую ответственность пользователя.',
  N5SystemCannotGuaranteeResponsibility: '5. Из-за внешних факторов (например, сбоев GPS) система не гарантирует точность результатов. Пользователь соглашается, что система не несет ответственности за точность данных.',
  N6BeAwareOfHome: '6. Так как сервис предоставляется через третью сторону (Яцзуйшоу), использование подразумевает, что третья сторона может узнать о вас и связаться. Это не является утечкой данных со стороны CargoWare/Дом Вольфганга.',
  DoNotRemindMeAgain: 'Больше не напоминать',
  IUnderstoodAndConfirmContinuing: 'Я ознакомлен, подтверждаю продолжение',
  ImportModeTip: 'Тип импорта "изменение": система сопоставляет данные порта по номеру декларации, контейнера, пломбы, типу и виду контейнера.\nТип импорта "сохранение": ваши исходные данные, не найденные в системе порта.',
  NewExportClearancePolicyTip: 'Приказ № 172 Шанхайской таможни о переключении условий выпуска, передача информации о морском выпуске на причал с квитанцией « погрузочный манифест», попросите клиента обратить внимание на состояние погрузочного манифеста после завершения таможенной очистки, аномалии своевременно связаться с клиентской службой для подтверждения. К тому времени избыточный манифест в упаковке не был своевременно удален, несвоевременная посадка, нестандартная сборка после выпуска, неудачное изменение данных манифеста, смешивание и повторное использование номера коносамента в течение двух лет повлияют на погрузку. Во - вторых, после получения обычной квитанции по погрузочному манифесту, если возникает необходимость в изменении, исключении или добавлении любого предварительно установленного манифеста, необходимо связаться с представителем судна, чтобы удалить погрузочный манифест и продолжить работу.',
  Upload0UploadFailed0: 'Успешно загружено: {0}, ошибок: {1}.',
  CustomerBranchScopeNot: 'Филиал доверителя указан неверно. Выберите корректный филиал.',
  BatchInitiateCollaboration: 'Массовый запуск кооперации',
  OrderCenterBranchNotAvailable: '{0} является принимающим филиалом, но конфигурация не активирована',
  BatchCollaboration: 'Массовая кооперация',
  SuccessCooperateX: 'Успешно скоординировано {0} операций',
  SuccessCooperateXFailY: 'Успешно: {0}, ошибок: {1}. Причины:',
  BusinessIsMaster: 'Операция {0} является основной',
  NotBranchCollaborationManageme: 'Операция {0}: не является принимающим филиалом и не имеет прав на управление кооперацией',
  OpOfficeNotCooperateBranch: 'Для операции {0} компания-исполнитель не может быть филиалом-кооператором',
  ExistCollaborationBranchRecord: 'Для операции {0} уже существует запись кооперации с принимающим филиалом {1}',
  EntrustedRecipient: 'Получатель поручения',
  NoteConsigneeCustomerExportImport: 'Примечание: Когда экспортируемый "грузополучатель" соответствует импортируемой "фидуциарной единице", убедитесь, что этот партнер имеет роль "клиент"!!',
  SetAsDefaultExportInfo: 'Установить текущие данные как экспортные по умолчанию',
  RecipientNotExist: 'Текущий грузополучатель не существует',
  ConsigneeCustomerNotExist: 'В настоящее время грузополучатель не имеет роли « клиента», не может быть использован в качестве доверенной организации, пожалуйста, пройдите в партнерский модуль для обслуживания информации, прежде чем повторно попробовать',
  CurrencyChangeCheckDiff: 'Поле Currency изменено на: {0}. Обратите внимание на десятичные разряды для [Prepaid], [Collect] и [Other Charge].',
  InvalidBillCannotConfirm: 'Невозможно подтвердить аннулированные счета. Проверьте.',
  Reviewed: 'Проверено',
  ApplicationPayInitiated: 'Запрос платежа отправлен',
  NotPrintedState: 'Не в статусе "распечатано"',
  StatementGenerated: 'Сверка сгенерирована',
  NotUnapproved: 'Не в статусе "не утверждено"',
  BillCannotVoid: '{0}Счёт {1} не может быть аннулирован, подтвердите, пожалуйста',
  SwitchHQNotView: 'Вы переключились на филиал HQ, у вас нет прав для просмотра страницы с деталями. Вернитесь на страницу списка и повторите запрос',
  JumpListPage: 'Перейти на страницу списка',
  WhenDepartmentBranchNewSelection: 'Если отдел или филиал, к которому относятся продажи/документация/обслуживание клиентов, не соответствует исходному документу, необходимо сделать повторный выбор!',
  OneClickQuery: 'Поиск в один клик',
  PreSubimtCheckTip: 'Примечание: после предварительной отправки бизнес-данных изменения не допускаются. После завершения отправки всех заказов вы можете использовать кнопку "Поиск в один клик" ниже для проверки неудачных заказов.',
  SubimtCheckTip: 'Примечание: после отправки бизнес-данных изменения не допускаются. После завершения отправки всех заказов вы можете использовать кнопку "Поиск в один клик" ниже для проверки неудачных заказов.',
  FinanceAuditCheckTip: 'Примечание: после проверки бизнес-данных изменения не допускаются. После завершения проверки всех заказов вы можете использовать кнопку "Поиск в один клик" ниже для проверки неудачных заказов.',
  SalesMapping: 'Отображение продаж:',
  SalesCargoSalesMap: 'Продажи доверенного бизнеса отображаются на продажи по сбору грузов операционного бизнеса',
  BusinessRemarks: 'Примечание к бизнесу',
  InternalEquipmentNote: 'Примечание к внутреннему оборудованию',
  QuantityWeightCubageConfirmed: 'Количество, вес и объём подтверждены',
  DataModifiedHasMergeContinueSave: 'Данные были изменены [{0}] в {1}, мы объединили изменения для вас. Сохранить?',
  SyncYongYouNotCancelReview: 'Уже отправлено в Yonyou, отмена проверки невозможна',
  PrintByBusinessNumber: 'Печать по номеру бизнеса',
  SelectNotBelongToCurBranch: 'Среди выбранных документов есть бизнес-документы, не принадлежащие текущему филиалу, изменения невозможны!',
  ClickFilePrivew: 'Нажмите на имя файла для предпросмотра',
  PackageDownload: 'Скачать архивом',
  CCPost: 'Копия должности',
  CCYourself: 'Копия себе',
  SaveCcAddresNextDefault: 'Сохранить текущие копии должностей (для использования по умолчанию в следующий раз)',
  ForMakingBatchTransferModifications: 'Для бизнес-номера {0} выбрана только информация по мелким билетам, но не выбрана информация по основным билетам. Массовый перевод на другой корабль невозможен. Выберите соответствующую информацию по основным билетам для изменения',
  TherePositionPleaseConfirmSuitable: '<b>{0}</b>Для должности доступно несколько вариантов, подтвердите, что выбранный сотрудник подходит.',
  TheWithBusinessStandardsSelection: '<b>{0}</b>Должность не соответствует бизнес-стандартам, сделайте повторный выбор.',
  PositionReSelectionReminder: 'Напоминание о повторном выборе должности',
  FeeReceivable: 'Расходы (дебиторская задолженность)',
  CostsPayable: 'Расходы (кредиторская задолженность)',
  ListOfHazardousMaterials: 'Список опасных грузов',
  DangerousGoodsInformation: 'Информация о опасных грузах',
  CustomsProcedures: 'Таможенные процедуры',
  CarDispatchInformation: 'Информация о выделении автомобиля',
  QuantityGrossWeightVolume: 'Количество/Брутто-вес/Объем',
  CustomFormBusinessBooking: 'Форма с пользовательскими настройками (бизнес-бронирование)',
  BusinessOperationInstruction: '[Инструкция по операционной деятельности]',
  NonEditable: 'Не редактируемый',
  BatchExportToImport: 'Партия экспорта в импорт',
  NonSupportImportationThroughEntry: 'Компании, не входящие в группу, не поддерживают импорт через экспорт-реимпорт.',
  BatchProcessingForTheReselect: 'Массовый перевод из экспорта в импорт поддерживает только пакетную обработку для одного и того же агента порта назначения. Пожалуйста, выберите заново!!',
  TheNotMeetTheConversion: 'Агент порта назначения и операционная компания не соответствуют условиям перевода экспорта в импорт!',
  TheThePortAgentExist: 'Не существует филиала агента порта назначения.',
  NotForReExport: 'Не подлежит перепродаже',
  ExportFunctionIsNotEnabled: 'Функция экспорта в импорт не включена',
  BatchProgressPleaseReferBelow: 'Процесс пакетного экспорта в импорт выполняется. См. результаты выполнения ниже!',
  TheDestinationPortAgentEmpty: 'Подключаемая филиал агента порта назначения не может быть пустой!',
  PleaseAFeeToEdit: 'Выберите плату для редактирования',
  PleaseFeesYouWantDelete: 'Пожалуйста, выберите нужные расходы для удаления!',
  AreWantToDeleteExpense: 'Вы уверены, что хотите удалить выбранные расходы?',
  ThisFeeIsNotEditable: 'Эта плата не подлежит редактированию.',
  TheNameCannotBeEmpty: 'Название расхода не может быть пустым.',
  BillUpTo3Currencies: 'Счет поддерживает до 3 валют!'
}
